import { lazy } from 'react';

export const ResetPassword = lazy(() => import('@/components/ResetPassword'));
export const ChangePassword = lazy(() => import('@/components/ChangePassword'));
export const OutletSignIn = lazy(() => import('@/Identity/OutletSignIn'));
export const SignIn = lazy(() => import('@/Identity/SignIn'));
